export default "__VITE_ASSET__CgHFMPqu__"